module.exports = __webpack_public_path__ + "static/media/NotoSansCJKkr-Regular.19b7d8d4.otf";